import {useState, useEffect} from 'react'
import {KTSVG, useDebounce} from '../../../template/helpers'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import {updateQuery} from '../slices/cdrFilterSlice'
import {shallowEqual} from 'react-redux'

const CDRSearchComponent = () => {
  const dispatch = useAppDispatch()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const debouncedSearchTerm = useDebounce(searchTerm, 500)
  const query = useAppSelector((state) => state.cdrFilter.query, shallowEqual)

  const handleClear = () => {
    setSearchTerm('')
    dispatch(updateQuery({offset: 0, search: undefined}))
  }

  useEffect(() => {
    if (query?.search) {
      setSearchTerm(query.search)
    }
  }, [query?.search])

  useEffect(() => {
    if (query?.search && searchTerm === '') {
      dispatch(updateQuery({offset: 0, search: undefined}))
    }
    if (
      debouncedSearchTerm !== '' &&
      debouncedSearchTerm !== undefined &&
      searchTerm !== undefined &&
      debouncedSearchTerm.length >= 3
    ) {
      dispatch(updateQuery({offset: 0, search: debouncedSearchTerm}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm])

  return (
    <div className='d-flex align-items-center position-relative my-1 me-2'>
      <div className='input-group input-group-solid'>
        <span className='input-group-text'>
          <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-2' />
        </span>

        <input
          type='text'
          data-kt-user-table-filter='search'
          className='form-control form-control-solid w-200px'
          placeholder='Быстрый поиск'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <span className='input-group-text px-1'>
          <button className='btn btn-small p-0 m-0 cursor-pointer' onClick={handleClear}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1 text-center' />
          </button>
        </span>
      </div>
    </div>
  )
}

export {CDRSearchComponent}
